interface SplashScreenModule {
  hide(): void;
  show(): void;
  preserve(): void;
}

class SplashScreenController {
  private static instance: SplashScreenController;
  private isPreserved: boolean = false;
  private splashModule: SplashScreenModule | null = null;

  private constructor() {
    if (this.isReactNative()) {
      // Lazy load react-native in RN environments only
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const { NativeModules } = require('react-native') as typeof import('react-native');
      this.splashModule = NativeModules.SplashScreen;
    }
  }

  public static getInstance(): SplashScreenController {
    if (!SplashScreenController.instance) {
      SplashScreenController.instance = new SplashScreenController();
    }
    return SplashScreenController.instance;
  }

  private isReactNative(): boolean {
    return typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
  }

  /**
   * Preserve the splash screen during app initialization
   */
  public preserve(): void {
    this.isPreserved = true;
    this.splashModule?.preserve();
  }

  /**
   * Remove the splash screen
   */
  public remove(): void {
    if (this.isPreserved) {
      this.splashModule?.hide();
      this.isPreserved = false;
    }
  }

  /**
   * Show the splash screen (useful for certain transitions)
   */
  public show(): void {
    this.splashModule?.show();
  }
}

export const SplashScreen = SplashScreenController.getInstance();
